// extracted by mini-css-extract-plugin
module.exports = {"container":"_25d45facb5--container--bjrA1","text":"_25d45facb5--text--BMIn8"};